import React, { useState, useEffect } from "react";
import Calendar from 'react-calendar';
import NewsList from './Newlist.js'
import 'react-calendar/dist/Calendar.css';
import './calendar.scss';
import icon6 from '../img/icon6.png'
import { getNewsList } from '../api/api'
function AllCalendar() {



    const formatMoth = (value, type) => {
        console.log(1)
        return 1
    }

    const [date, setDate] = useState(new Date());
    const [isSlide, changeSlie] = useState(false);
    const [filter, setFilter] = useState('全部');
    const [newsList, setNewsList] = useState([]);
    const [filter_news, setFilterNews] = useState([])



    const tablist = ['全部', '宏观', '事件', '新股']
    const changeDate = (date) => {
        console.log(date)
        setDate(date)
        getNewsList({
            date: date.getFullYear() + '-' + Number(date.getMonth() + 1) + '-' + date.getDate()
        }).then(res => {
            setFilter('全部')
            console.log(res.data.events[0].events)
            setFilterNews(res.data.events[0].events )
            setNewsList(res.data.events[0].events )
        })
    }
    const changeSlide = () => {
        changeSlie(!isSlide)
    }

    const filterNews = item => {
        setFilter(item)
        let init_array = []
        if(item == '全部') {
            setFilterNews(newsList)
        }else {
            newsList.map(news => {
                if(news.event_type_name == item){
                    init_array.push(news)
                }
            })
            setFilterNews(init_array)
        }



        
    }
    useEffect(() => {
        getNewsList({
            date: date.getFullYear() + '-' + Number(date.getMonth() + 1) + '-' + date.getDate()
        }).then(res => {

            setNewsList(res.data.events[0].events )
            setFilterNews(res.data.events[0].events )
        })
    }, [])

    return (
        <div>
            <div className={isSlide ? 'm-calendar slide-down' : 'm-calendar slide-up'}>
                <Calendar onChange={changeDate} value={date} formatShortWeekday={(locale, value) => ['日', '一', '二', '三', '四', '五', '六'][value.getDay()]}
                    formatLongDate={(locale, value) => value.getDate()}
                />
                <img src={icon6} className={isSlide ? 'u-icon6 down' : 'u-icon6 '} onClick={changeSlide} />
            </div>

            <div className="m-newslist">
                <div className="m-tab">
                    {
                        tablist.map((item, index) => {
                            return (
                                <span onClick={() => { filterNews(item) }} className={item == filter ? 'active' : ''} key={index}>{item} <i></i></span>
                            )
                        })
                    }
                </div>

                <NewsList list={filter_news} />


            </div>

        </div>
    )
}
export default AllCalendar